var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserOutlinedRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1213 19.6346C5.05865 19.6346 0.95459 15.5305 0.95459 10.4679C0.95459 5.40533 5.05865 1.30127 10.1213 1.30127C15.1839 1.30127 19.2879 5.40533 19.2879 10.4679C19.2879 15.5305 15.1839 19.6346 10.1213 19.6346ZM16.2875 14.7385C17.1284 13.5265 17.6213 12.0548 17.6213 10.4679C17.6213 6.3258 14.2634 2.96794 10.1213 2.96794C5.97912 2.96794 2.62126 6.3258 2.62126 10.4679C2.62126 12.0548 3.11408 13.5265 3.95501 14.7385C4.89288 13.4997 7.09676 12.9679 10.1213 12.9679C13.1458 12.9679 15.3496 13.4997 16.2875 14.7385ZM15.0918 16.0844C14.8479 15.2074 13.0957 14.6346 10.1213 14.6346C7.14677 14.6346 5.39459 15.2074 5.15069 16.0844C6.47401 17.2564 8.21454 17.9679 10.1213 17.9679C12.028 17.9679 13.7685 17.2564 15.0918 16.0844ZM10.1213 5.46794C8.10384 5.46794 6.78792 6.93107 6.78792 8.80127C6.78792 11.6574 8.25531 12.9679 10.1213 12.9679C11.9697 12.9679 13.4546 11.7009 13.4546 8.96794C13.4546 7.06925 12.1331 5.46794 10.1213 5.46794ZM8.45459 8.80127C8.45459 10.6923 9.13643 11.3013 10.1213 11.3013C11.1027 11.3013 11.7879 10.7166 11.7879 8.96794C11.7879 7.92662 11.1343 7.1346 10.1213 7.1346C9.06604 7.1346 8.45459 7.81446 8.45459 8.80127Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOutlinedRounded);
export default __webpack_public_path__ + "static/media/user-outlined-rounded.964cdbc4.svg";
export { ForwardRef as ReactComponent };